import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { MouseEventHandler, ReactChild, ReactNode } from "react";

import "./CustomInput.css";

type CustomInputProps = {
  children: ReactChild;
  label?: string;
  error?: string;
  id?: string;
  labelId?: string;
  onClear?: MouseEventHandler<HTMLDivElement>;
  button?: ReactNode;
  leadingContent?: ReactNode;
  showErrorText?: boolean;
  warning?: string;
};

const CustomInput = ({
  children,
  label,
  id,
  labelId,
  error,
  onClear,
  button,
  leadingContent,
  showErrorText = true,
  warning,
}: CustomInputProps) => {
  return (
    <div
      className={classNames("CustomInput", "CustomInput__container", {
        CustomInput__error: !!error,
        CustomInput__warning: !error && warning,
      })}
    >
      {(label || error) && (
        <div className="inputLabel__container">
          {label ? (
            <label htmlFor={id} id={labelId}>
              {label}
            </label>
          ) : undefined}
          {showErrorText && error && (
            <div className="error__container">
              <small>{error}</small>
              <FontAwesomeIcon icon="exclamation-circle" />
            </div>
          )}
        </div>
      )}
      <div className="CustomInput__wrapper">
        {leadingContent}
        <div className="CustomInput__input">
          {children}
          {onClear && (
            <div onClick={onClear} className="CustomInput__input--clear">
              X
            </div>
          )}
        </div>
        {button}
      </div>
    </div>
  );
};

export default CustomInput;
